import { Routes } from '@angular/router';
import { ItemService } from '@softapps/handel/esl/core';
import { AuthenticationGuard, AuthorizationGuard } from '@softline/auth';
import { SOFTLINE_PERMISSION_ESL } from './esl-link.shared';
import { EslLinkAssociateService } from './services/esl-link-associate.service';

/**
 * @deprecated use provideEslLinkStorageProviders instead
 */
export const eslLinkRoutes: Routes = [
  {
    path: 'esl-link',
    children: [
      {
        path: '',
        providers: [EslLinkAssociateService],
        children: [
          {
            path: 'associate',
            loadComponent: () =>
              import('./pages/associate/associate.component').then(
                (o) => o.AssociateComponent
              ),
          },
          {
            path: 'associate/:esl',
            loadComponent: () =>
              import('./pages/associate-items/associate-items.component').then(
                (o) => o.AssociateItemsComponent
              ),
          },
          {
            path: 'dissociate',
            loadComponent: () =>
              import('./pages/dissociate/dissociate.component').then(
                (o) => o.DissociateComponent
              ),
          },
        ],
      },
      {
        path: 'flash',
        loadComponent: () =>
          import('./pages/flash/flash.component').then((o) => o.FlashComponent),
      },
      { path: '**', redirectTo: '/esl-link/associate' },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: { permission: SOFTLINE_PERMISSION_ESL },
    providers: [ItemService],
  },
];
